/**
 * Identifies the message transaction type.
 * tag: 3016
 * @readonly
 * @enum {number} (int)
 */
export enum AlgoCertificateRequestTransType {
  /** New */
  New = 0,
  /** Cancel */
  Cancel = 1,
}
